export class PaymentUUID 
{
    static NAMIRASOFT_JOB_ARRANGER = {
        sales_items: {
            JOB_ARRANGER_MEMBERSHIP: {
                id: "pym-sit-0@jaj-member",
                offers: {
                    MONTHLY_MEMBERSHIP: {
                        id: "pym-ofr-c882e68827d7",
                        items: {
                            MONTHLY: {
                                id: "pym-ofr-itm-ece89dd6",
                            }
                        }
                    },
                    ANNUAL_MEMBERSHIP: {
                        id: "pym-ofr-943ff3f16b42",
                        items: {
                            ANNUALLY: {
                                id: "pym-ofr-itm-50ec8c77"
                            }
                        }
                    }
                }
            }
        }
    };
    static NAMIRASOFT_BILL_WATCH = {
        sales_items: {
            BILL_WATCH_FOR_AWS: {
                id: "pym-sit-0@bw-----aws",
                offers: {
                    HOURLY_USAGE: {
                        id: "pym-ofr-98d1fcc64ed2",
                        items: {
                            FIX_PER_HOUR: {
                                id: "pym-ofr-itm-969c9ab5"
                            }
                        }
                    }
                }
            },
            BILL_WATCH_FOR_AZURE: {
                id: "pym-sit-0@bw---azure",
                offers: {
                    HOURLY_USAGE: {
                        id: "pym-ofr-8e5183c3fa74",
                        items: {
                            FIX_PER_HOUR: {
                                id: "pym-ofr-itm-004dddfc"
                            }
                        }
                    }
                }
            },
            BILL_WATCH_FOR_GCP: {
                id: "pym-sit-0@bw-----gcp",
                offers: {
                    HOURLY_USAGE: {
                        id: "pym-ofr-3b1830f46f19",
                        items: {
                            FIX_PER_HOUR: {
                                id: "pym-ofr-itm-7ac93d85"
                            }
                        }
                    }
                }
            }
        }
    };
};